export class WorkDayFormModel {
  constructor(workDay = {}) {
    this.dayOfTheWeek = workDay.dayOfTheWeek;
    this.opensAt = workDay.opensAt;
    this.closesAt = workDay.closesAt;
  }
}
